{
  "name": "file-monitoring-app",
  "version": "1.6.1-67-upgrade-angular.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --ssl --host localhost.sparbanken.me",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "test": "ng test --watch=false --code-coverage",
    "lint": "ng lint",
    "install": "cp ./package.json ./src/assets",
    "style-lint": "stylelint \"src/**/*.scss\" --fix"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.9",
    "@angular/common": "^20.3.9",
    "@angular/compiler": "^20.3.9",
    "@angular/core": "^20.3.9",
    "@angular/forms": "^20.3.9",
    "@angular/platform-browser": "^20.3.9",
    "@angular/platform-browser-dynamic": "^20.3.9",
    "@angular/router": "^20.3.9",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.3.8",
    "@angular/cdk": "^20.2.10",
    "@angular/cli": "^20.3.8",
    "@angular/compiler-cli": "^20.3.9",
    "@angular/material": "^20.2.10",
    "@angular/material-luxon-adapter": "^20.2.10",
    "@sparbanken-syd/auth-backend": "^2.4.2",
    "@sparbanken-syd/personnummer": "^3.0.1",
    "@sparbanken-syd/sparbanken-syd-bankid": "^20.2.2",
    "@sparbanken-syd/sparbanken-syd-qr": "^20.0.0",
    "@sparbanken-syd/sparbanken-syd-theme": "^20.3.0",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^20.2.3",
    "@types/jasmine": "~5.1.12",
    "@typescript-eslint/eslint-plugin": "^8.46.2",
    "@typescript-eslint/parser": "^8.46.2",
    "angular-eslint": "^20.5.0",
    "eslint": "^9.38.0",
    "jasmine-core": "~5.12.1",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "luxon": "^3.7.2",
    "postcss": "^8.5.6",
    "stylelint": "^16.25.0",
    "stylelint-config-standard-scss": "^16.0.0",
    "stylelint-scss": "^6.12.1",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.46.2"
  }
}
